import React, { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { 
    apiCollectionState,
    collectionsCurState,
    collectionsModeleState,
    collectionsShareState,
    collectionsState,
    collectionTabState,
    currentPageCollectionAtom,
    currentPageModeleAtom,
    currentPageShareAtom,
    idDataEntityState,
    idLayerEditState,
    loadingState,
    openCollectionShareStates,
    openCollectionStates,
    reloadCollectionState,
    searchQueryCollectionAtom,
    searchQueryModeleAtom,
    searchQueryShareAtom,
    sortConfigCollectionAtom,
    sortConfigModeleAtom,
    sortConfigShareAtom,
    typeCollectionState,
    userDataState 
} from '../../atoms/CollectionState';
import ResultForm from '../resultat/resultatForm';
import genStyles from '../generale.module.css';
import menuStyles from '../resultat/searchActionsMenu.module.css';
import FullScreenModal from '../modalForm/fullScreenModal';
import AddCollectionForm from './addCollectionForm';
import DeleteCollectionForm from './deleteCollectionForm';
import ShowService from '../../service/showService';
import DrawService from '../../service/DrawService';
import ExcelService from '../../service/excelService';
import TooltipForm from '../tooltipForm';

export default function CollectionList({ 
    onSelect, 
    getDataCollectionShare, 
    sharedCollection, 
    modeleCollection 
}) {
  
    const collections = useRecoilValue(collectionsState);
    const collectionsShareto = useRecoilValue(collectionsShareState);
    const collectionsModele = useRecoilValue(collectionsModeleState);
    const [allOpen, setAllOpen] = useState(false); 
    const [openStates, setOpenStates] = useRecoilState(openCollectionStates);
    const [allOpenShare, setAllOpenShare] = useState(false); 
    const [openShareStates, setOpenShareStates] = useRecoilState(openCollectionShareStates);    
    const setIdCollectionSelected = useSetRecoilState(idDataEntityState);
    const [showModal, setShowModal] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [typeConfirm, setTypeConfirm] = useState();
    const [objetCur, setObjetCur] = useState({});    
    const [sortConfigCollection, setSortConfigCollection] = useRecoilState(sortConfigCollectionAtom);
    const [searchQueryCollection, setSearchQueryCollection] = useRecoilState(searchQueryCollectionAtom);
    const [currentPageCollection, setCurrentPageCollection] = useRecoilState(currentPageCollectionAtom);
    const [sortConfigShare, setSortConfigShare] = useRecoilState(sortConfigShareAtom);
    const [searchQueryShare, setSearchQueryShare] = useRecoilState(searchQueryShareAtom);
    const [currentPageShare, setCurrentPageShare] = useRecoilState(currentPageShareAtom);
    const [sortConfigModele, setSortConfigModele] = useRecoilState(sortConfigModeleAtom);
    const [searchQueryModele, setSearchQueryModele] = useRecoilState(searchQueryModeleAtom);
    const [currentPageModele, setCurrentPageModele] = useRecoilState(currentPageModeleAtom);
    const setCollectionsCurState = useSetRecoilState(collectionsCurState); 
    const [layerEdit,setLayerEdit] = useRecoilState(idLayerEditState);
    const settypeCollection = useSetRecoilState(typeCollectionState);
    const api_collection = useRecoilValue(apiCollectionState);
    const user_data = useRecoilValue(userDataState);  
    const setLoading = useSetRecoilState(loadingState);
    const [activeTab, setActiveTab] = useRecoilState(collectionTabState);
    const setReloadCollection = useSetRecoilState(reloadCollectionState);
    
    useEffect(() => {
        DrawService.onLayerSelect = (layerData) => {
             // désactiver l'edition du couche encours
             if(layerEdit){
                DrawService.desactiveEdition(layerEdit);
            }

              // Cherche d'abord dans collections
            let item = collections.find(c => c.id === layerData.collection_id);
            
            // Si pas trouvé, cherche dans collectionsShareto
            if (!item) {
                item = collectionsShareto.find(c => c.id === layerData.collection_id);
                DrawService.typeCollectionCur = "shared";
            }else{
                DrawService.typeCollectionCur = "collection";
            }

            if (item) {                
                selectAllDataRow(item);
                DrawService.infoCollectionCur = item;                
            }
            
            setLayerEdit(layerData.id);
        };
    }, [collections, collectionsShareto]);
    
    const toggleAll = (type) => {
        const newOpenStates = {};
        switch (type) {
            case 'collection':{
                const newState = !allOpen;
                setAllOpen(newState);               
                const newOpenStates = {};
                collections.forEach((item) => {
                    newOpenStates[item.id] = newState;
                    if (newState) {
                        showCollection(item,'show');
                    } else {
                        hideCollection(item);
                    }
                });
                setOpenStates(newOpenStates);
              break;
            }
            case 'share':{
                const newState = !allOpenShare;
                setAllOpenShare(newState);
                collectionsShareto.forEach((item) => {
                    newOpenStates[item.id] = newState;
                    if (newState) {
                        showCollection(item,'show');
                    } else {
                        hideCollection(item);
                    }
                });
                setOpenShareStates(newOpenStates);
              break;
            }      
        }        
    };

    const toggleOne = (collection,type,action) => {
        const id = collection.id;
        const toggleState = (prev) => {
            const isOpen = prev[id];
            const updated = { ...prev, [id]: !isOpen };
            
            // Action différente selon l'état
            if (isOpen) {
                hideCollection(collection);
            } else {
                showCollection(collection,action);
            }
            const hasAnyOpen = Object.values(updated).some((v) => v === true);
            if (type === 'collection') {
              setAllOpen(hasAnyOpen);
            } else if (type === 'share') {
              setAllOpenShare(hasAnyOpen);
            }
            return updated;
        };

        switch (type) {
            case 'collection':  
                setOpenStates((prev) =>
                    toggleState(prev)
                );
                break;
    
            case 'share':
                setOpenShareStates((prev) =>
                    toggleState(prev)
                );
                break;
    
            default:
                console.warn(`Type inconnu : ${type}`);
        }
       
       
    };

    const hideCollection = (collection) => {
        DrawService.removeLayerCollection(collection,'collection');
    }

    const showCollection = (collection,action) => {
        const geojson = collection.geojson;
        if(geojson && geojson.features !== null){
            ShowService.addEntitesToMap(geojson,action);
        }
    };

    const zoomCollection = (collection,type) => {
        const geojson = collection.geojson;
        // Vérifier que le geojson a des features avec des géométries valides
        if (!geojson || !geojson.features || geojson.features.length === 0) {
            return;
        }
        // Vérifier qu'au moins une feature a une géométrie valide
        const hasValidGeometry = geojson.features.some(feature => 
            feature && feature.geometry && feature.geometry.coordinates
        );
        if (!hasValidGeometry) {
            return;
        }
        
        const isOpen = type === 'collection' ? openStates[collection.id] : openShareStates[collection.id];
        if(!isOpen){
            toggleOne(collection, type,'zoom');
        }
        DrawService.zoomCollection(geojson);
    };

    const deleteCollection = (collection) => {
        setObjetCur(collection);
        setTypeConfirm('collection');
        setShowConfirmModal(true);
    };

    const DuplicateCollection = (collection) => {
        setObjetCur(collection);
        setTypeConfirm('duplicate');
        setShowConfirmModal(true);
    };

    const columns = [
        {
            key: 'affiche',
            sortable: false,
            width:'20px',
            label: (
                <a onClick={() => toggleAll('collection')} >
                    <TooltipForm content={`Afficher/Cacher toute les collections`}>
                        <i className={`${allOpen ? "fa-solid fa-eye" : "fa-solid fa-eye-slash"} ${genStyles.maincolorfirsttext}`}></i>
                    </TooltipForm>
                </a>
            ),
            render: (_, row) => (
                <a onClick={(e) => {
                    e.preventDefault(); 
                    toggleOne(row,'collection','show');
                }}>
                    <TooltipForm content={`Afficher/Cacher la collection`}>
                        <i  className={`${openStates[row.id] ? "fa-solid fa-eye" : "fa-solid fa-eye-slash"} ${genStyles.bgcolorfirsttext}`}></i>
                    </TooltipForm>
                </a>
            )
        },
        { key: 'nom_affiche', label: 'Nom de la collection', selectable: true },
        { key: 'nb_entite', label: 'Entités', align: 'center',width:'70px', selectable: true },
        {
            key: 'actions',
            sortable: false,
            label: '',
            subColumns: [
                { key: 'action1', label: '' },
                { key: 'action2', label: '' },
                { key: 'action3', label: '' },
                { key: 'action4', label: '' },
              ],
            render: (_, row) =>  [
                <td key={`zoom-${row.id}`} style={{ width:'30px'}} className='center-align'>
                    <a onClick={() => zoomCollection(row,'collection')}>
                        <TooltipForm content={`Zoomer sur l'emprise de la collection`}>
                            <i className={`fa-solid fa-magnifying-glass-plus yellow-text text-darken-3 ${genStyles.fontSize16}`}></i>
                        </TooltipForm>
                    </a>
                </td>,
                <td key={`copy-${row.id}`} style={{ width:'30px'}} className='center-align'>
                    <a onClick={() => DuplicateCollection(row)} >
                        <TooltipForm content={`Dupliquer la collection et les entités`}>
                            <i className={`fa-solid fa-copy brown-text text-darken-2 ${genStyles.fontSize16}`}></i>
                        </TooltipForm>
                    </a>
                </td>,
                <td key={`edit-${row.id}`} style={{width:'30px'}} className='center-align'>
                    <a onClick={() => editCollection(row)} >
                        <TooltipForm content={`Éditer le nom de la collection`}>
                            <i className={`fa-solid fa-pen-to-square blue-text text-darken-3 ${genStyles.fontSize16}`}></i>
                        </TooltipForm>
                    </a>
                </td>,
                <td key={`delete-${row.id}`} style={{ width:'30px'}} className='center-align'>
                     <a onClick={() => deleteCollection(row)}>
                        <TooltipForm content={`Supprimer la collection et les entités`}>
                            <i className={`fa-solid fa-trash-can red-text text-darken-2 ${genStyles.fontSize16}`}></i>
                        </TooltipForm>
                    </a>
                </td>,
            ]
        }
    ];

    const columnsShare = [
        {
            key: 'affiche',
            sortable: false,
            width:'20px',
            label: (
                <a onClick={() => toggleAll('share')} >
                    <TooltipForm content={`Afficher/Cacher toutes les collections`}>
                        <i className={`${allOpenShare ? "fa-solid fa-eye" : "fa-solid fa-eye-slash"} ${genStyles.maincolorfirsttext}`}></i>                  
                    </TooltipForm>
                </a>  
            ),
            render: (_, row) => (
                <a onClick={(e) => {
                    e.preventDefault(); 
                    toggleOne(row,'share','show');
                }}>
                    <TooltipForm content={`Afficher/Cacher la collections`}>
                        <i  className={`${openShareStates[row.id] ? "fa-solid fa-eye" : "fa-solid fa-eye-slash"} ${genStyles.bgcolorfirsttext}`}></i>
                    </TooltipForm>
                </a>
            )
        },
        { key: 'nom_affiche', label: 'Nom de la collection', selectable: true },
        { key: 'nb_entite', label: 'Entités', align: 'center',width:'70px', selectable: true },
        {
            key: 'actions',
            sortable: false,
            label: '',
            subColumns: [
                { key: 'action1', label: '' },
                { key: 'action2', label: '' },
              ],
            render: (_, row) =>  [
                <td key={`zoom-${row.id}`} style={{width:'30px'}} className='center-align'>
                    <a onClick={() => zoomCollection(row,'share')} >
                        <TooltipForm content={`Zoomer la collections`}>
                            <i className={`fa-solid fa-magnifying-glass-plus yellow-text text-darken-3 ${genStyles.fontSize16}`}></i>
                        </TooltipForm>
                    </a>
                </td>,
                <td key={`share-${row.id}`} style={{width:'30px'}} className='center-align'>
                    <a onClick={() => unshareCollection(row)} >
                        <TooltipForm content={`Annuler le partage`}>
                            <i className={`fa-kit fa-solid-share-nodes-slash red-text text-darken-3 ${genStyles.fontSize16}`}></i>
                        </TooltipForm>
                    </a>
                </td>,
            ]
        }
    ];

    
    const typeFR = {
        textMarker: { img: <i className={`fa-solid fa-text ${genStyles.fontSize20}`}></i> },
        marker: { img: <i className={`fa-solid fa-location-dot ${genStyles.fontSize20}`}></i> },
        circle: { img: <i className={`fa-solid fa-circle ${genStyles.fontSize20}`}></i> },
        polyline: { img: <i className={`fa-kit fa-draw-polyline-icon ${genStyles.fontSize20}`}></i> },
        polygon: { img: <i className={`fa-solid fa-vector-polygon ${genStyles.fontSize20}`}></i> },
        rectangle: { img: <i className={`fa-solid fa-vector-square ${genStyles.fontSize20}`}></i> },
    };

    const columnsModele = [       
        { key: 'libelle', label: 'Nom', width:'70px', selectable: true },
        { 
            key: 'type', 
            label: "Type",
            align: 'center', 
            selectable: true,
            width:'70px',
            render: (_, row) => {
                const typeInfo = typeFR[row.type];
                let parsedOptions = {};
                try {
                  parsedOptions = row?.options
                    ? typeof row.options === "string"
                      ? JSON.parse(row.options)
                      : row.options
                    : {};
                } catch {
                  parsedOptions = {};
                }
                const color = parsedOptions?.color || parsedOptions?.icon?.options?.markerColor || '#000';
            
                return (
                <div className="cursor-pointer center-align">
                    <span style={{ color }}>
                    {typeInfo?.img}
                    </span>
                </div>
                );
            }
        },
        { key: 'description', label: 'Description',  selectable: true },
        {
            key: 'actions',
            sortable: false,
            label: '',
            render: (_, row) =>  (
                <a onClick={(e) => {
                    e.preventDefault(); 
                    // toggleOne(row.id,'modele');
                }}>
                    <i  className={`fa-solid fa-pen-to-square blue-text text-darken-3 ${genStyles.fontSize16}`}></i>
                </a>
            )
        }
    ];

    const selectAllDataRow = (row) => {
        onSelect(row.nom_affiche);
        setIdCollectionSelected(row.id);
        setCollectionsCurState(row);
        
        // Vérifie si la collection est dans collections
        const isLocal = collections.some(col => col.id === row.id);
        const isShared = collectionsShareto.some(col => col.id === row.id);

        let type = null;
        if (isLocal) type = 'collection';
        else if (isShared) type = 'shared';
        else type = 'unknown'; // au cas où ce n'est dans aucun des deux

        settypeCollection(type);
        DrawService.redrawEntityCollection(row.id);
    };

    const openPopup = () => {
        setObjetCur('');
        setShowModal(true); 
    };

    const editCollection = (collection) => {
        setObjetCur(collection);
        setShowModal(true); 
    };

    const exportXlsCollection = (type) => {
        const dataexport = type === 'collection' ? collections : collectionsShareto;
        ExcelService.exportCollection(dataexport,type);
    };

    const reloadSharedCollection = () => {
        let api = api_collection+ user_data.account.port+ '/';
        let userId = user_data.user.id;
        setLoading(true);
        getDataCollectionShare(api, userId);
    };

    const unshareCollection = (collection) => {
        setObjetCur(collection);
        setTypeConfirm('unshare');
        setShowConfirmModal(true);
    };

    return (
        <>
        <div className="row">
            <div className="col s12 center-align">
                <p className={`${genStyles.italic} ${genStyles.fontSize15} mb0`}>Le module <span className={genStyles.bold}>collections</span> vous permet de <span className={genStyles.bold}>créer</span>, <span className={genStyles.bold}>personnaliser</span>  et <span className={genStyles.bold}>partager</span>  du contenu cartographique</p>
            </div>
        </div>

        <div className="row">
            {sharedCollection && (
                <div className="col s12 mb20 mt10">
                    <div className={`${genStyles.tabsCtn}`}>
                        <a onClick={(e)=>{ e.preventDefault(); setActiveTab('collections'); }}
                           className={`cursor-pointer ${genStyles.tabBtn} ${activeTab === 'collections' ? genStyles.tabBtnActive : genStyles.tabBtnInactive}`}>
                            <i className={`fa-solid fa-crown ${genStyles.icomargin}`}></i>
                            VOS COLLECTIONS
                        </a>
                        <a onClick={(e)=>{ e.preventDefault(); setActiveTab('shared'); }}
                           className={`cursor-pointer ${genStyles.tabBtn} ${activeTab === 'shared' ? genStyles.tabBtnActive : genStyles.tabBtnInactive}`}>
                            <i className={`fa-solid fa-share-nodes ${genStyles.icomargin}`}></i>
                            COLLECTIONS PARTAGÉES
                        </a>
                    </div>
                </div>
            )}

            {(!sharedCollection || activeTab === 'collections') && (
            <>
            <div className="col s12 center-align">
                <ResultForm 
                    data={collections} 
                    columns={columns} 
                    onSelectRow={selectAllDataRow} 
                    pageSize={10} 
                    tableHeight="auto"
                    textpaginate="collections" 
                    texteSearch="Rechercher une collection"             
                    sortConfig={sortConfigCollection}
                    setSortConfig={setSortConfigCollection}
                    searchQuery={searchQueryCollection}
                    setSearchQuery={setSearchQueryCollection}
                    currentPage={currentPageCollection}
                    setCurrentPage={setCurrentPageCollection}
                    actionsButtonRight={
                        <>
                            <TooltipForm content={`Ajouter une collection`}>
                                <button
                                    type="button"
                                    className={menuStyles.butMenu}
                                    onClick={openPopup}
                                >
                                    <i className={`fa-sharp fa-regular fa-square-plus black-text`}></i>
                                </button>
                            </TooltipForm>
                            <TooltipForm content={`Exporter mes collections`}>
                                <button
                                    type="button"
                                    className={menuStyles.butMenu}
                                    onClick={() => exportXlsCollection("collection")}
                                >
                                    <i className={`fa-sharp fa-regular fa-file-xls black-text`}></i>
                                </button>
                            </TooltipForm>
                        </>
                    }
                />
            </div>
            </>
            )}

            {sharedCollection && activeTab === 'shared' && (
                <>
                    <div className="col s12 center-align">
                        <ResultForm 
                            data={collectionsShareto} 
                            columns={columnsShare} 
                            onSelectRow={selectAllDataRow} 
                            pageSize={10} 
                            tableHeight="auto"
                            textpaginate="collections" 
                            texteSearch="Rechercher une collection partagée"             
                            sortConfig={sortConfigShare}
                            setSortConfig={setSortConfigShare}
                            searchQuery={searchQueryShare}
                            setSearchQuery={setSearchQueryShare}
                            currentPage={currentPageShare}
                            setCurrentPage={setCurrentPageShare}
                            actionsButtonRight={
                                <>
                                    <TooltipForm content={`Actualiser`}>
                                        <button
                                            type="button"
                                            className={menuStyles.butMenu}
                                            onClick={reloadSharedCollection}
                                        >
                                            <i className={`fa-solid fa-rotate black-text text-darken-2`}></i>
                                        </button>
                                    </TooltipForm>
                                    <TooltipForm content={`Exporter les collections partagées`}>
                                        <button
                                            type="button"
                                            className={menuStyles.butMenu}
                                            onClick={() => exportXlsCollection("share")}
                                        >
                                            <i className={`fa-sharp fa-regular fa-file-xls black-text`}></i>
                                        </button>
                                    </TooltipForm>
                                </>
                            }                         
                        />
                    </div>
                </>
            )}

            {modeleCollection && false && (
                <>
                    <div className="col s12 center-align">
                        <p className="section-title mt10 mb0">
                            <span className={`${genStyles.bold} ${genStyles.fontSize18} ${genStyles.bgcolorfirsttext}`}> 
                                <i className={`fa-solid fa-share-nodes black-text ${genStyles.icomargin}`}></i>
                                VOS MODÈLES
                            </span>
                        </p>
                    </div>
                    <div className="col s12 center-align">
                    <ResultForm 
                        data={collectionsModele} 
                        columns={columnsModele} 
                        onSelectRow={selectAllDataRow} 
                        pageSize={10} 
                        tableHeight="auto"
                        textpaginate="modèles" 
                        texteSearch="Rechercher un modèle"                
                        sortConfig={sortConfigModele}
                        setSortConfig={setSortConfigModele}
                        searchQuery={searchQueryModele}
                        setSearchQuery={setSearchQueryModele}
                        currentPage={currentPageModele}
                        setCurrentPage={setCurrentPageModele}
                    />
                    </div>
                </>
            )}
            {showModal && (
                <FullScreenModal>
                    <AddCollectionForm onClose={() => setShowModal(false)} objetCur={objetCur} />
                </FullScreenModal>
            )}
            {showConfirmModal && (
                <FullScreenModal>
                    <DeleteCollectionForm 
                        onClose={() => setShowConfirmModal(false)} 
                        objectCur={objetCur} 
                        type={typeConfirm} 
                        setEntites={null} 
                        reloadSharedCollection={reloadSharedCollection} 
                    />
                </FullScreenModal>
            )}
        </div>
        </>        
    );
}
